export const getTeamCategoryList = state => {
    return state.list
}

export const getTeamCategoryDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/teamCategory/getters.js